import { render } from "./Consultance_Formation.vue?vue&type=template&id=4196ea04&scoped=true"
import script from "./Consultance_Formation.vue?vue&type=script&lang=js"
export * from "./Consultance_Formation.vue?vue&type=script&lang=js"

import "./Consultance_Formation.vue?vue&type=style&index=0&id=4196ea04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4196ea04"]])

export default __exports__